// removed by extract-text-webpack-plugin
module.exports = {"videoContainer":"BackgroundVideo__videoContainer___2vMcZ","videoWidth":"BackgroundVideo__videoWidth___W-ZKv","videoOverlay":"BackgroundVideo__videoOverlay___3jNwu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Video/BackgroundVideo.scss
// module id = 1550
// module chunks = 0